import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AdminLogin } from "../../../Service/Login";
import { setAuthenticationSession } from "../../../Service/authSession";
import { LoginImages } from "../../../reusableUI/images";
import secureLocalStorage from "react-secure-storage";
import { showToast } from "../../../reusableUI/toaster";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [OTP, setOTP] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {}, []);

  const validateInputs = () => {
    if (!email || !OTP) {
      showToast("Please fill in all fields.", "Error");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToast("Please enter a valid email address.", "Error");
      return false;
    }

    return true;
  };

  const login = async () => {
    if (!validateInputs()) return;

    setLoginLoading(true);
    try {
      let data = { email: email, password: OTP };
      let _login = await AdminLogin(data);
      if (_login && _login.error === false) {
        const userRole = _login.data.role;
        const loginType = "adminside";

        secureLocalStorage.setItem("loginTime", new Date().getTime());
        secureLocalStorage.setItem("email", _login.data.id);

        showToast(_login.message, "Success");

        setAuthenticationSession({
          token: _login.data.token,
          expiresIn: _login.data.expiresIn,
          id: _login.data.id,
          role: userRole,
          accountType: "admin",
        });

        if (loginType === "adminside" && userRole === "super user") {
          navigate("/dashboard");
        } else if (loginType === "adminside" && userRole === "support") {
          navigate("/support");
        } else if (loginType === "adminside") {
          navigate("/booking");
        } else {
          navigate("/login");
        }
      } else {
        showToast(
          _login?.message || "Login failed. Please try again.",
          "Error"
        );
      }
    } catch (error) {
      console.error("Login error:", error);
      showToast(
        "An unexpected error occurred. Please try again later.",
        "Error"
      );
    } finally {
      setLoginLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      login();
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen font-[Inter] bg-[#F8F9FB]">
      {/* Left Side Image */}
      <div className="hidden lg:block lg:w-1/2 h-screen">
        <div
          className="h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${LoginImages.cover})`,
          }}
        ></div>
      </div>
      {/* Right Side Login */}
      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 px-6 py-12">
        <img src={LoginImages.logo} className="h-12 w-40 mb-10" alt="Logo" />
        <div className="bg-white shadow-xl rounded-2xl px-10 py-8 w-full max-w-md">
          <h2 className="text-2xl font-bold text-[#1A1A1A] mb-8 text-center ">
            Login
          </h2>
          <div className="mb-6">
            <label className="block text-sm font-medium text-[#8E8E8E] mb-2">
              Email Address
            </label>
            <input
              type="text"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#E0E0E0] rounded-lg px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              required
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="mb-8">
            <label className="block text-sm font-medium text-[#8E8E8E] mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter your password"
                value={OTP}
                onChange={(e) => setOTP(e.target.value)}
                className="w-full border border-[#E0E0E0] rounded-lg px-4 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-400 transition pr-12"
                required
                onKeyDown={handleKeyDown}
              />
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-xl text-[#8E8E8E]"
                tabIndex={-1}
              >
                {!passwordVisible ? <IoEyeOffOutline /> : <FaRegEye />}
              </button>
            </div>
          </div>
          <button
            disabled={loginLoading}
            className={`w-full bg-custom-gradient rounded-lg py-2 text-white font-semibold text-lg shadow-md transition mb-4 flex items-center justify-center gap-2 ${
              loginLoading ? 'opacity-70 cursor-not-allowed scale-100' : 'hover:scale-105'
            }`}
            onClick={login}
          >
            {loginLoading ? (
              <>
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
          <div className="flex justify-center">
            <Link
              to="/#home"
              className="text-blue-600 underline text-sm font-medium"
            >
              Go back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
